/**
 * Coming Soon Countdown Timer
 * Handles countdown functionality for the coming soon section
 */

(function() {
  'use strict';

  // Initialize timer when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTimer);
  } else {
    initTimer();
  }

  function initTimer() {
    const timerElements = document.querySelectorAll('.coming-soon-timer[data-countdown-end]');
    
    timerElements.forEach(timerElement => {
      const endDateStr = timerElement.getAttribute('data-countdown-end');
      
      if (!endDateStr) {
        console.warn('Coming Soon Timer: No end date specified');
        return;
      }

      // Parse the end date
      const endDate = parseEndDate(endDateStr);
      
      if (!endDate || isNaN(endDate.getTime())) {
        console.error('Coming Soon Timer: Invalid date format. Use YYYY-MM-DD HH:MM:SS');
        timerElement.querySelector('.timer-display').textContent = '00:00:00:00';
        return;
      }

      // Get timer display elements
      const daysEl = timerElement.querySelector('.timer-days');
      const hoursEl = timerElement.querySelector('.timer-hours');
      const minutesEl = timerElement.querySelector('.timer-minutes');
      const secondsEl = timerElement.querySelector('.timer-seconds');

      // Update timer immediately
      updateTimer(endDate, daysEl, hoursEl, minutesEl, secondsEl);

      // Update timer every second
      const intervalId = setInterval(() => {
        updateTimer(endDate, daysEl, hoursEl, minutesEl, secondsEl);
      }, 1000);

      // Store interval ID for cleanup if needed
      timerElement.dataset.intervalId = intervalId;
    });
  }

  /**
   * Parse end date string into Date object
   * @param {string} dateStr - Date string in format YYYY-MM-DD HH:MM:SS
   * @returns {Date} Parsed date object
   */
  function parseEndDate(dateStr) {
    // Remove extra spaces and normalize
    const cleaned = dateStr.trim();
    
    // Try parsing ISO format first (YYYY-MM-DD HH:MM:SS)
    const isoFormat = cleaned.replace(' ', 'T');
    let date = new Date(isoFormat);
    
    // If that fails, try direct parsing
    if (isNaN(date.getTime())) {
      date = new Date(cleaned);
    }
    
    return date;
  }

  /**
   * Update timer display
   * @param {Date} endDate - Target end date
   * @param {HTMLElement} daysEl - Days display element
   * @param {HTMLElement} hoursEl - Hours display element
   * @param {HTMLElement} minutesEl - Minutes display element
   * @param {HTMLElement} secondsEl - Seconds display element
   */
  function updateTimer(endDate, daysEl, hoursEl, minutesEl, secondsEl) {
    const now = new Date();
    const timeRemaining = endDate - now;

    // Check if countdown has ended
    if (timeRemaining <= 0) {
      daysEl.textContent = '00';
      hoursEl.textContent = '00';
      minutesEl.textContent = '00';
      secondsEl.textContent = '00';
      return;
    }

    // Calculate time units
    const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

    // Update display with padded values
    daysEl.textContent = padZero(days);
    hoursEl.textContent = padZero(hours);
    minutesEl.textContent = padZero(minutes);
    secondsEl.textContent = padZero(seconds);
  }

  /**
   * Pad number with leading zero if needed
   * @param {number} num - Number to pad
   * @returns {string} Padded string
   */
  function padZero(num) {
    return num.toString().padStart(2, '0');
  }

  // Cleanup function for theme editor
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:unload', function(event) {
      const section = event.target;
      const timer = section.querySelector('.coming-soon-timer[data-interval-id]');
      
      if (timer && timer.dataset.intervalId) {
        clearInterval(parseInt(timer.dataset.intervalId));
      }
    });

    // Reinitialize on section load in theme editor
    document.addEventListener('shopify:section:load', function() {
      initTimer();
    });
  }
})();
